import { Component, OnInit } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { Router } from '@angular/router';
import {
  HiringManagerLevels,
  jobLocation,
  priorityOptions,
  timeZone,
  validFileTypes,
  editFields,
} from './hiring-request.config';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HiringRequestService } from './hiring-request.service';
import {
  DntLeaderDetail,
  EmployeeData,
  hiringRequestDDValues,
  HiringRequestResponse,
  HiringRequestResponseData,
  PanelMemberFormValue,
  ProjectData,
} from '@interfaces/hiring-manager.model';
import { ToasterService } from '@services/toaster.service';
import { GlobalErrorService } from '@services/global-error.service';
import {
  getDntLeaderOptions,
  getDntOptions,
  getHiringManagerOptions,
  getLobOptions,
  getpanelMemberOptions,
  getPojectIdOptions,
  getProjectNameOptions,
  getProjectDropdownOptions,
  getSkillOptions,
  getVendorOptions,
  jobDescriptionValidator,
  patchHiringRequestFormValues,
  setupPanelMemberValidators,
  disableFields,
  getFormValuesWithDisabledControls,
  panelMemberPairValidator,
} from './hiring-request.helper';
import { DataService } from '@services/data.service';
import { VendorDetails } from '@interfaces/vendor.model';
import { getFieldError } from './hiring-request.helper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { debounceTime } from 'rxjs/operators';
import { ErrorMessages, HIRING_REQUEST_TEXT } from '@constants/constants';
import { HiringManagerOpenpositionsService } from '../hiring-manager-openpositions/hiring-manager-openpositions.service';
import { buildHiringRequestBody } from './hiring-request-body.builder';
import { experienceValidator, maxOverallExperienceValidator, maxLengthValidator, restrictInvalidKeyPress } from '@utils/validators';
import { FileUploadService } from '@services/file-upload.service';
import { RoutesEnum } from '@app/shared/constants/global.enum';
import { LENGTH } from '@shared/config/allowedKeys.config';

@Component({
  selector: 'app-hiring-request',
  templateUrl: './hiring-request.component.html',
  styleUrl: './hiring-request.component.scss',
})
export class HiringRequestComponent implements OnInit {
  jobLocation = jobLocation;
  priorityOptions = priorityOptions;
  timeZoneOneOptions = cloneDeep(timeZone);
  timeZoneTwoOptions = cloneDeep(timeZone);
  timeZoneThreeOptions = cloneDeep(timeZone);
  maxLengthTwo = LENGTH.MAX_LENGTH_TWO;
  maxLengthThree = LENGTH.MAX_LENGTH_THREE;
  private unsubscribe$ = new Subject<void>();
  selectedFile: string | null = null;
  fileSize: string | null = null;
  hiringRequestForm!: FormGroup;
  isprojectIdValid: boolean = true;
  isSubmitted: boolean = false;
  hiringRequestText = HIRING_REQUEST_TEXT;
  fileError: string | null = null;
  jdFilePath: string = '';
  isEditMode: boolean = false;
  openPositionId: string | null = null;
  hiringRequest: HiringRequestResponseData | null = null;
  isLoading = false;
  hiringRequestId: number = 0;
  defaultValue: string = '';
  defaultLabel: string = '';
   routesEnum = RoutesEnum;

  lobOptions: hiringRequestDDValues[] = [];
  DntOptions: hiringRequestDDValues[] = [];
  dntLeaderDetails: DntLeaderDetail[] = [];
  hiringManagerOptions: hiringRequestDDValues[] = [];
  panelMemberOneOptions: hiringRequestDDValues[] = [];
  panelMemberTwoOptions: hiringRequestDDValues[] = [];
  panelMemberThreeOptions: hiringRequestDDValues[] = [];
  projects: ProjectData[] = [];
  projectNameOptions: hiringRequestDDValues[] = [];
  projectIdOptions: hiringRequestDDValues[] = [];
  mandatorySkillOptions: hiringRequestDDValues[] = [];
  gthSkillOptions: hiringRequestDDValues[] = [];
  vendorOptions: hiringRequestDDValues[] = [];
  private mandatoryVendorOptions: hiringRequestDDValues[] = [];
  hiringManagerData: EmployeeData[] = [];
  selectedEmployeeEmail: string = '';
  currentDate: Date = new Date();
  dynamicPanelMemberOptions: hiringRequestDDValues[] = [];
  dynamicTimeZoneOptions = cloneDeep(timeZone);

  constructor(
    private router: Router,
    private hrfb: FormBuilder,
    private hiringRequestService: HiringRequestService,
    private fileUploadService: FileUploadService,
    private toasterService: ToasterService,
    private errorHandler: GlobalErrorService,
    private dataService: DataService,
    private openPositionsService: HiringManagerOpenpositionsService,
 ) {}
  get panelMembers(): FormArray {
    return this.hiringRequestForm.get('panelMembers') as FormArray;
  }
addPanelMember(): void {
  const panelMemberGroup = this.hrfb.group({
    panelMember: [null],
    panelMemberTimezone: [null],
  });
  this.panelMembers.push(panelMemberGroup);
  this.panelMembers.updateValueAndValidity();
}
onePanelMember() {
  const panelMembersArray = this.hiringRequestForm.get('panelMembers') as FormArray;
  if (panelMembersArray.length === 0) {
    panelMembersArray.push(this.hrfb.group({
      panelMember: [null],
      panelMemberTimezone: [null]
    }));
  }
  panelMembersArray.updateValueAndValidity();
}

  ngOnInit() {
    this.initializeForm();
    const state = history.state;
    if (state) {
      const formState = state.formState;
      if (formState == 'edit') {
        this.isEditMode = true;
        this.hiringRequestId = state.openPositionData?.hiringRequestId;
        this.getHiringRequestDataById(this.hiringRequestId);
      }
    }
    if (this.isEditMode) {
      disableFields(this.hiringRequestForm, ['lineOfBusiness', 'dntLeader']);
      this.isLoading = true;
    } else {
      this.loadDataFromService();
    }
    const primarySkillsControl = this.hiringRequestForm.get('mandatorySkills');
    if (primarySkillsControl) {
      primarySkillsControl.valueChanges
        .pipe(debounceTime(300), takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.filterSecondarySkills();
        });
    }
    const secondarySkillsControl =
      this.hiringRequestForm.get('goodToHaveSkills');
    if (secondarySkillsControl) {
      secondarySkillsControl.valueChanges
        .pipe(debounceTime(300), takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.filterPrimarySkills();
        });
    }
    this.hiringRequestForm.addControl('panelMembers', this.hrfb.array([]));
    this.onePanelMember();
    this.hiringRequestForm.get('vendors')?.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.enforceMandatoryVendors());
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  initializeForm(): void {
    this.hiringRequestForm = this.hrfb.group(
      {
        lineOfBusiness: ['', [Validators.required]],
        dntLeader: ['', [Validators.required]],
        projectName: ['', [Validators.required]],
        jobTitle: ['', [Validators.required]],
        numberOfPositions: [
          '',
          [
            Validators.required,
            Validators.pattern(/^[0-9]*$/),
            Validators.min(1),
          ],
        ],
        jobLocation: ['', [Validators.required]],
        overAllExp: [
          '',
          [
            Validators.required,
            Validators.pattern(/^[0-9]*\.?[0-9]+$/),
            maxOverallExperienceValidator(40),
            experienceValidator('overAllExp', 'relExp'),
            maxLengthValidator(5),
          ],
        ], // Adding maxOverallExperienceValidator
        relExp: [
          '',
          [
            Validators.required,
            Validators.pattern(/^[0-9]*\.?[0-9]+$/),
            maxOverallExperienceValidator(40),
            experienceValidator('overAllExp', 'relExp'),
            maxLengthValidator(5),
          ],
        ], // Adding relevantExperienceValidator
        startDate: ['', [Validators.required, this.dateValidator]],
        mandatorySkills: ['', [Validators.required]],
        goodToHaveSkills: [''],
        comment: [''],
        jobDescription: ['', [jobDescriptionValidator(this.selectedFile)]],
        hiringManager: ['', [Validators.required]],
        hirManEmail: [''],
        panelMemberOne: ['', [Validators.required]],
        panelMemberOneTimezone: ['', [Validators.required]],
        panelMemberTwo: [''],
        panelMemberTwoTimezone: [''],
        priorityOptions: ['', [Validators.required]],
        vendors: ['', [Validators.required]],
        panelMembers: this.hrfb.array([]),
      },
      { validators: experienceValidator('overAllExp', 'relExp') },
    );
    (this.hiringRequestForm.get('panelMembers') as FormArray).setValidators(panelMemberPairValidator());
    setupPanelMemberValidators(this.hiringRequestForm);
  }
  onInput(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let filteredValue = input.value.replace(/[^0-9]/g, '');
    if (filteredValue.startsWith('0')) {
      filteredValue = filteredValue.replace(/^0+/, '');
    }
    this.hiringRequestForm.get(controlName)?.setValue(filteredValue);
  }

  preventEnterKey(event: Event): void {
    event.preventDefault();
  }

  preventInvalidKeyPress(event: KeyboardEvent) {
    restrictInvalidKeyPress(event);
  }

  dateValidator(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const selectedDate = new Date(control.value);
    if (isNaN(selectedDate.getTime())) {
      return { invalidDateFormat: true };
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const minimumDate = new Date(today.setDate(today.getDate() + 3)); // Minimum date should be 3 days from today
    return selectedDate < minimumDate ? { invalidDate: true } : null;
  }

  getHiringRequestDataById(hiringRequestId: number) {
    this.hiringRequestService.getHiringRequestById(hiringRequestId).subscribe(
      (hirReqRes: HiringRequestResponse) => {
        this.hiringRequest = hirReqRes.data;
        this.loadDataFromService();
      },
      (error) => {
        this.errorHandler.logComponentError(error);
      },
    );
  }
  filterSecondarySkills() {
    const selectedPrimarySkills: hiringRequestDDValues[] = Array.isArray(
      this.hiringRequestForm.get('mandatorySkills')?.value,
    )
      ? this.hiringRequestForm.get('mandatorySkills')!.value
      : [];
    const selectedSecondarySkills: hiringRequestDDValues[] = Array.isArray(
      this.hiringRequestForm.get('goodToHaveSkills')?.value,
    )
      ? this.hiringRequestForm.get('goodToHaveSkills')!.value
      : [];
    if (
      this.mandatorySkillOptions &&
      Array.isArray(this.mandatorySkillOptions)
    ) {
      this.gthSkillOptions = this.mandatorySkillOptions.filter(
        (skill) =>
          !selectedPrimarySkills.some(
            (primarySkill) => primarySkill.value === skill.value,
          ),
      );
      const secondarySkillsNotInPrimary = selectedSecondarySkills.filter(
        (secondarySkill) =>
          !this?.gthSkillOptions.some(
            (skill) => skill.value === secondarySkill.value,
          ),
      );
      this.gthSkillOptions = [
        ...secondarySkillsNotInPrimary,
        ...this.gthSkillOptions,
      ];
    }
  }
  filterPrimarySkills() {
    const selectedPrimarySkills: hiringRequestDDValues[] = Array.isArray(
      this.hiringRequestForm.get('mandatorySkills')?.value,
    )
      ? this.hiringRequestForm.get('mandatorySkills')!.value
      : [];
    const selectedSecondarySkills: hiringRequestDDValues[] = Array.isArray(
      this.hiringRequestForm.get('goodToHaveSkills')?.value,
    )
      ? this.hiringRequestForm.get('goodToHaveSkills')!.value
      : [];
    if (this.mandatorySkillOptions) {
      this.mandatorySkillOptions = this.mandatorySkillOptions.filter(
        (skill) =>
          !selectedSecondarySkills.some(
            (secondarySkill) => secondarySkill.value === skill.value,
          ),
      );
      const primarySkillsNotInSecondary = selectedPrimarySkills.filter(
        (primarySkill) =>
          !this.mandatorySkillOptions.some(
            (skill) => skill.value === primarySkill.value,
          ),
      );
      this.mandatorySkillOptions = [
        ...primarySkillsNotInSecondary,
        ...this.mandatorySkillOptions,
      ];
    }
  }
hasPanelMemberPairError(panelMember: AbstractControl, controlName: string): boolean {
  const control = panelMember.get(controlName);
  return !!(control && control.hasError('requiredPair') && this.isSubmitted);
}
  onPrimarySkillsChange() {
    this.filterSecondarySkills();
  }
  onGoodToHaveSkillsChange() {
    this.filterPrimarySkills();
  }
  loadDataFromService() {
    this.lobOptions = getLobOptions(this.dataService.lobs());

    this.projects = this.dataService.projects().data.project;

    if (this.hiringRequest) {
      this.DntOptions = getDntLeaderOptions(
        this.hiringRequest,
        this.dataService.employees(),
      );
      const lobId = this.hiringRequest.lobId;
      this.onLobChange(lobId);
    }

    this.projectIdOptions = getPojectIdOptions(
      this.dataService.projects().data.project,
    );
    this.mandatorySkillOptions = getSkillOptions(this.dataService.skills());
    this.gthSkillOptions = getSkillOptions(this.dataService.skills());

    if (
      this.mandatorySkillOptions &&
      this.hiringRequestForm.get('mandatorySkills')?.value
    ) {
      this.filterSecondarySkills();
    }
    if (
      this.gthSkillOptions &&
      this.hiringRequestForm.get('goodToHaveSkills')?.value
    ) {
      this.filterPrimarySkills();
    }

    this.hiringManagerOptions = getHiringManagerOptions(
      this.dataService.employees(),
    );
    this.panelMemberOneOptions = getpanelMemberOptions(
      this.dataService.employees(),
    );
    this.panelMemberTwoOptions = getpanelMemberOptions(
      this.dataService.employees(),
    );
    this.dynamicPanelMemberOptions = getpanelMemberOptions(
      this.dataService.employees(),
    );
    // Global-vendor config (vendor.is_global_vendor) is DB-driven and can
    // change any time, so refresh the vendor list on every form open rather
    // than trusting the localStorage-cached master data. Render from cache
    // first (keeps edit-mode patch ordering), then rebuild when the fresh
    // list arrives.
    this.setVendorOptionsFrom(this.dataService.vendors());
    this.refreshVendorOptions();
    this.hiringManagerData = this.dataService
      .employees()
      .data?.filter(
        (item: EmployeeData) =>
          HiringManagerLevels?.includes(item.level) && item.poiType === 'EMP',
      );
  }
  patchFormValues() {
    if (this.hiringRequest) {
      this.selectedFile = this.hiringRequest?.jobDescriptionFilePath
        ? (this.hiringRequest?.jobDescriptionFilePath.split('/').pop() ?? null)
        : null;
      this.jdFilePath = this.hiringRequest?.jobDescriptionFilePath ?? '';
      this.hiringRequestForm
        .get('jobDescription')
        ?.setValidators(jobDescriptionValidator(this.selectedFile));
      this.hiringRequestForm.get('jobDescription')?.updateValueAndValidity();
      patchHiringRequestFormValues(
        this.hiringRequest,
        this.hiringRequestForm,
        this.lobOptions,
        this.DntOptions,
        this.projectNameOptions,
        this.projectIdOptions,
        this.jobLocation,
        this.priorityOptions,
        this.mandatorySkillOptions,
        this.gthSkillOptions,
        this.hiringManagerOptions,
        this.panelMemberOneOptions,
        this.panelMemberTwoOptions,
        this.panelMemberThreeOptions,
        this.timeZoneOneOptions,
        this.timeZoneTwoOptions,
        this.timeZoneThreeOptions,
        this.vendorOptions,
      );
      const selectedVendorIds =
        this.hiringRequest.hiringVendors?.map((vendor) => vendor.vendorId) ||
        [];
      this.vendorOptions = this.vendorOptions.map((option) => ({
        ...option,
      }));
      this.reorderSelectedToTop();
      const panelArray = this.panelMembers;
      panelArray.clear();
      if (this.hiringRequest.hiringPanel && this.hiringRequest.hiringPanel.length > 1) {
        const dynamicPanels = this.hiringRequest.hiringPanel.slice(2);
        dynamicPanels.forEach(panel => {
          const panelMemberOption = this.dynamicPanelMemberOptions.find(opt => opt.value === panel.employeeId) || null;
          const timeZoneOption = this.dynamicTimeZoneOptions.find(opt => opt.value === panel.panelAvailabilityTimezone) || null;
          panelArray.push(this.hrfb.group({
          panelMember: [panelMemberOption, []],
          panelMemberTimezone: [timeZoneOption, []]
          }));
        });
      }
      this.onePanelMember();
      if (this.hiringRequest.yearsOfOverallExperience === 0) {
        this.hiringRequestForm.get('overAllExp')?.setValue('0');
      }
      if (this.hiringRequest.yearsOfRelevantExperience === 0) {
        this.hiringRequestForm.get('relExp')?.setValue('0');
      }
    }
    this.isLoading = false;
  }

  private setVendorOptionsFrom(vendors: VendorDetails[] | null | undefined): void {
    this.vendorOptions = getVendorOptions(vendors ?? []);
    this.applyMandatoryVendorLocks();
  }

  /** Pull the latest vendor list from the API so newly (un)flagged global
   *  vendors reflect without a full app reload / cache bust. Falls back to
   *  the cached list on error. */
  private refreshVendorOptions(): void {
    this.hiringRequestService
      .getVendorData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        const vendors = res?.data?.vendors;
        if (vendors && vendors.length) {
          this.dataService.vendors.set(vendors);
          this.setVendorOptionsFrom(vendors);
        }
      });
  }

  private applyMandatoryVendorLocks(): void {
    // Global vendors are flagged in the DB (vendor.is_global_vendor) and
    // surfaced via the vendors API, replacing the previously hardcoded
    // MANDATORY_VENDOR_NAMES list. They are pre-selected and locked, kept in
    // alphabetical order at the top of the list.
    const mandatoryOrdered: hiringRequestDDValues[] = [];
    const rest: hiringRequestDDValues[] = [];
    this.vendorOptions.forEach((option) => {
      if (option.isGlobalVendor) {
        mandatoryOrdered.push({ ...option, selected: true, disabled: true });
      } else {
        rest.push(option);
      }
    });
    mandatoryOrdered.sort((a, b) => a.label.localeCompare(b.label));
    this.mandatoryVendorOptions = mandatoryOrdered;
    this.vendorOptions = [...mandatoryOrdered, ...rest];
    this.enforceMandatoryVendors();
    this.reorderSelectedToTop();
  }

  private reorderSelectedToTop(): void {
    const ctrl = this.hiringRequestForm.get('vendors');
    if (!ctrl) return;
    const current = Array.isArray(ctrl.value) ? ctrl.value : [];
    const selectedValues = new Set(
      current.map((o: hiringRequestDDValues) => o?.value),
    );
    const mandatoryValues = new Set(
      this.mandatoryVendorOptions.map((o) => o.value),
    );
    const otherSelected: hiringRequestDDValues[] = [];
    const unselected: hiringRequestDDValues[] = [];
    this.vendorOptions.forEach((opt) => {
      if (mandatoryValues.has(opt.value)) return;
      if (selectedValues.has(opt.value)) otherSelected.push(opt);
      else unselected.push(opt);
    });
    this.vendorOptions = [
      ...this.mandatoryVendorOptions,
      ...otherSelected,
      ...unselected,
    ];
  }

  private enforceMandatoryVendors(): void {
    if (this.mandatoryVendorOptions.length === 0) return;
    const ctrl = this.hiringRequestForm.get('vendors');
    if (!ctrl) return;
    const current = Array.isArray(ctrl.value) ? ctrl.value : [];
    const currentValues = new Set(
      current.map((o: hiringRequestDDValues) => o?.value),
    );
    const missing = this.mandatoryVendorOptions.filter(
      (o) => !currentValues.has(o.value),
    );
    if (missing.length > 0) {
      ctrl.setValue([...current, ...missing], { emitEvent: false });
    }
  }

  isFieldValid(fieldName: string): boolean {
    const control = this.hiringRequestForm.get(fieldName);
    if (this.isSubmitted || control?.touched) {
      return control?.valid ?? false;
    }
    return true;
  }

  getFieldError(fieldName: string): string {
    const control = this.hiringRequestForm.get(fieldName);
    return getFieldError(control);
  }

  onFieldChange(event: Event, fieldName: string): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    if (!isNaN(Number(value)) && value.startsWith('-')) {
      value = value.substring(1);
    }
    // Enforce 4-digit constraint
    if (value.length > 5) {
      value = value.substring(0, 5);
    }
    this.hiringRequestForm.get(fieldName)?.setValue(value);
    const control = this.hiringRequestForm.get(fieldName);
    control?.setValue(value);
    control?.updateValueAndValidity();
    if (fieldName === 'overAllExp') {
      this.hiringRequestForm.get('overAllExp')?.updateValueAndValidity();
      this.hiringRequestForm.get('relExp')?.updateValueAndValidity();
    } else if (fieldName === 'relExp') {
      this.hiringRequestForm.get('relExp')?.updateValueAndValidity();
    }
  }

  navigateBack() {
    this.router.navigate(['hiring-manager']);
  }

  onFileSelected(event: Event): void {
    this.fileError = null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.type;
      const fileSizeInBytes = file.size;
      this.selectedFile = input.files[0].name;

      if (!validFileTypes.includes(fileType)) {
        this.fileError =
          'Invalid file type. Please upload a PDF or Word document.';
        this.selectedFile = null;
        this.hiringRequestForm
          .get('jobDescription')
          ?.setErrors({ invalidFileType: true });
        return;
      }

      if (fileSizeInBytes > 10 * 1024 * 1024) {
        this.fileSize = Math.floor(fileSizeInBytes / (1024 * 1024)) + ' MB';
        this.fileError = 'File size exceeds the maximum allowed size of 10MB.';
        this.selectedFile = null;
        this.hiringRequestForm
          .get('jobDescription')
          ?.setErrors({ fileTooLarge: true });
        return;
      } else if (fileSizeInBytes > 1024) {
        this.fileSize = Math.floor(fileSizeInBytes / 1024) + ' KB';
      }

      this.selectedFile = file.name;
      this.hiringRequestForm
        .get('jobDescription')
        ?.setValidators(jobDescriptionValidator(this.selectedFile));
      this.hiringRequestForm.get('jobDescription')?.updateValueAndValidity();
      this.fileUploadService.uploadFile(file, 'job_description').subscribe(
        (res) => {
          if (res?.success && res?.filePath) {
            this.jdFilePath = res?.filePath;
            this.hiringRequestForm.get('jobDescription')?.setValue(this.jdFilePath);
          } else {
            this.toasterService.showError(res?.message || ErrorMessages.FileUploadFailed, 'Error');
            this.jdFilePath = '';
            this.hiringRequestForm.get('jobDescription')?.setValue('');
            this.selectedFile = null;
          }
        },
        (error) => {
          this.toasterService.showError(error.error, 'Error');
          this.jdFilePath = '';
          this.hiringRequestForm.get('jobDescription')?.setValue('');
          this.selectedFile = null;
        },
      );
    } else {
      this.hiringRequestForm
        .get('jobDescription')
        ?.setValidators(jobDescriptionValidator(this.selectedFile));
      this.hiringRequestForm.get('jobDescription')?.updateValueAndValidity();
    }
  }

  onDeleteFile() {
    this.selectedFile = null;
    this.hiringRequestForm.get('jobDescription')?.setValue('');
    this.hiringRequestForm
      .get('jobDescription')
      ?.setValidators(jobDescriptionValidator(this.selectedFile));
    this.hiringRequestForm.get('jobDescription')?.updateValueAndValidity();
  }

  onEmployeeChange(event: string) {
    if (this.hiringManagerData && this.hiringManagerData?.length) {
      const selectedEmployee = this.hiringManagerData?.find(
        (emp) => emp.employeeName === event,
      );
      if (selectedEmployee) {
        this.selectedEmployeeEmail = selectedEmployee.email;
      } else {
        this.selectedEmployeeEmail = '';
      }
    }
  }

  onLobChange(lobId: number) {
    this.DntOptions = [];
    this.projectNameOptions = [];
    this.hiringRequestForm.get('dntLeader')?.reset();
    this.hiringRequestForm.get('projectName')?.reset();

    this.hiringRequestService.getDntProjectData(lobId).subscribe(
      (dntProjRes) => {
        this.dntLeaderDetails = dntProjRes?.data?.dntLeaderDetails || [];
        this.DntOptions = getDntOptions(dntProjRes);


        this.projectNameOptions = getProjectDropdownOptions(
          this.dataService.projects()
        );

        if (this.isEditMode && this.hiringRequest && this.dntLeaderDetails.length > 0) {
          this.onDntChange(this.hiringRequest.leaderEmployeeId);
          this.patchFormValues();
        }
      },
      (error) => {
        this.errorHandler.logComponentError(error);
      },
    );
  }

  onDntChange(dntId: string) {
    this.projectNameOptions = [];
    this.hiringRequestForm.get('projectName')?.reset();
    const selectedDntLeader = this.dntLeaderDetails.find(
      (leader) => leader.dntLeaderEmpId === dntId.toString(),
    );
    if (selectedDntLeader) {
      this.projectNameOptions = getProjectNameOptions(selectedDntLeader);
    } else {
      this.projectNameOptions = [];
    }
  }

  onCancel() {
    this.router.navigate(['hiring-manager']);
  }

  onPublish() {
    const userProfile = this.dataService.userProfile();
    this.isSubmitted = true;
    this.hiringRequestForm.markAllAsTouched();
    this.hiringRequestForm.updateValueAndValidity();
    this.panelMembers.markAllAsTouched();
    this.panelMembers.updateValueAndValidity();

    if (this.hiringRequestForm.invalid) {
      return;
    }
    if (this.hiringRequestForm.valid) {
      let formValues;
      if (this.isEditMode) {
        formValues = getFormValuesWithDisabledControls(
          this.hiringRequestForm,
          editFields,
        );
      } else {
        formValues = this.hiringRequestForm.value;
      }

      const body = buildHiringRequestBody(
        formValues,
        this.jdFilePath,
        this.isEditMode,
        userProfile,
        this.hiringRequest,
        this.hiringRequestId
      );

      const request$ = this.isEditMode
        ? this.hiringRequestService.updateHiringRequest(body)
        : this.hiringRequestService.createHiringRequest(body);

      request$.subscribe(
        (_res) => {
          const successMessage = this.isEditMode
            ? 'Hiring Request form updated successfully!'
            : 'Hiring Request form submitted successfully!';
          this.toasterService.showSuccess(successMessage, 'Success');
          this.hiringRequestForm.reset();
          this.resetPanelMembers();
          // no refresh here: the open-positions ngOnInit clears the cached
          // signal and refetches on landing — a second fetch fired from here
          // races it (the earlier response can land after the later one)
          this.openPositionsService.openPositionsSignal.set(null);
          this.router.navigate(['hiring-manager']);
        },
        (error) => {
          this.toasterService.showError(error.error.message, 'Error');
        },
      );
    }
  }

   navigateToVendorManagement(): void {
    this.router.navigate([RoutesEnum.VendorManagement]);
  }
  resetPanelMembers() {
    const panelMembersArray = this.hiringRequestForm.get('panelMembers') as FormArray;
    panelMembersArray.clear();
    this.onePanelMember();
  }
}
